import { defineComponent, ref, computed } from "vue";
import { addCdnHost } from "./component-library245.mjs";
import PlayPauseButton from "./component-library14.mjs";
import { useReducedMotion } from "./component-library88.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "video-player",
  props: {
    controls: { type: Boolean, default: false },
    src: { default: "" },
    poster: { default: void 0 },
    loop: { type: Boolean, default: false },
    autoplay: { type: Boolean, default: false },
    muted: { type: Boolean, default: false },
    videoType: { default: void 0 },
    playsinline: { type: Boolean, default: true },
    preload: { default: "auto" },
    playButtonCentered: { type: Boolean, default: true },
    hidePlayButton: { type: Boolean, default: false },
    videoAriaLabel: { default: "Werbevideo" },
    playButtonAriaLabel: { default: "Video abspielen" },
    pauseButtonAriaLabel: { default: "Video pausieren" }
  },
  setup(__props, { expose }) {
    const props = __props;
    const isReducedMotion = useReducedMotion();
    const isPlaying = ref(false);
    const videoElement = ref(null);
    const videoSrc = computed(() => addCdnHost(props.src));
    const posterSrc = computed(() => props.poster ? addCdnHost(props.poster) : void 0);
    const doShowPlayButton = computed(() => !isPlaying.value && !props.hidePlayButton);
    const type = computed(() => {
      if (props.videoType)
        return props.videoType;
      return videoSrc.value.replace(/.*\.(\w+)$/i, (_name, fileext) => fileext.toLowerCase());
    });
    const togglePlay = () => {
      const element = videoElement.value;
      if (!element)
        return;
      if (element.paused)
        element.play();
      else
        element.pause();
    };
    expose({ togglePlay });
    return { __sfc: true, isReducedMotion, props, isPlaying, videoElement, videoSrc, posterSrc, doShowPlayButton, type, togglePlay, PlayPauseButton };
  }
});
export {
  _sfc_main as default
};
